import { mapState, mapActions } from 'vuex'
import PresentationApi from '@/api/presentation'

import constants from '@/constant'
import Utils from '@/util'
import Socket from '@/socket'
import EventBus from '@/eventBus'

const { gaCategories } = constants
export default {
  data() {
    return {
      importSocketData: null,
    }
  },
  computed: {
    ...mapState({
      isOnboardingV3Showing: (state) => state.indicators.isOnboardingV3Showing,
    }),
    gaCategory() {
      if (this.$route.name == 'PresentationDetail') {
        return gaCategories.PRESENTATION_EDITOR
      }
      if (this.isOnboardingV3Showing) {
        return gaCategories.PRESENTATION_LIST
      }
      return gaCategories.PRESENTATION_LIST
    },
    eventLabel() {
      return this.isOnboardingV3Showing ? 'Import from onboarding' : ''
    },
    eventValue() {
      return this.isOnboardingV3Showing ? 'Onboarding option' : ''
    },
  },
  methods: {
    ...mapActions(['setCurrentUserHasCreatedPresentationAction']),
    handleImporting(id) {
      Socket.subscribe(`user-${id}`, (doc) => {
        this.importSocketData = doc
        if (doc.type === 'import') {
          if (doc.status === 1) {
            if (doc.data.images.length > 100) {
              this._handleInvalidateImport()
              return
            }
            this._addSlidesOrCreateNewPresentation()
          } else if (doc.status === 3) {
            this._handleImportingError()
          }
        }
      })
    },

    _handleInvalidateImport() {
      this.$store.state.importStatus = 1
      this.$store.state.importError =
                '<div>Maximum slide amount is 100 slides. <br /> Please try again with a smaller file.</div>'
      Utils.gaTrackEvent(this.gaCategory, 'Import > Upload file', this.eventLabel, `${this.eventValue}${this.eventValue ? ' > ' : ''}'Exceed 100 slides'`)
      Utils.showToastError('Import failed')
    },

    _addSlidesOrCreateNewPresentation() {
      const { importPayload, nameFile } = this._setPayloadForImporting()

      if (this.importSocketData.data.presentationId) {
        this._addImportedSlidesIntoPresentation(this.importSocketData.data.presentationId, false, importPayload)
        Utils.gaTrackEvent(this.gaCategory, 'Create new slide', 'Import')
      } else {
        this._createNewPresentation({
          name: nameFile,
          socketId: Socket.getSocketId(),
          presentationImport: true,
          folderId: this.importSocketData.data.folderId,
        }, importPayload)
      }
    },

    _setPayloadForImporting() {
      this.$store.state.importStatus = 3
      const { urlFile } = this.importSocketData.data
      const images = []
      let nameFile = this.importSocketData.data.fileName
      if (this.importSocketData.data.fileName.length > 69) {
        nameFile = `${this.importSocketData.data.fileName.substring(0, 66)}...`
      }
      const arrDataImages = this.importSocketData.data.images.sort((a, b) => {
        return a.index - b.index
      })
      arrDataImages.forEach((item, key) => {
        const index = key + 1

        images.push({
          name: `Page ${index} - ${nameFile}`,
          url: item.nameFile,
        })
      })

      const importPayload = {
        images,
        fileUrl: urlFile,
        fileSize: this.importSocketData.data.size,
      }
      return { importPayload, nameFile }
    },

    async _addImportedSlidesIntoPresentation(presentationId, isNewPresentation, payload) {
      try {
        const importPayload = {
          presentationId,
          isNewPresentation,
          ...payload,
        }
        const data = await PresentationApi.importDocument(importPayload)
        this._handleAfterImportDocument(data, presentationId)
      } catch (error) {
        this.$store.state.importError =
              "<div>Import failed. If this file has text in custom fonts, it’s recommended that you convert it into PDF first before importing to AhaSlides.<br />Please try again or contact us at <a href='mailto:hi@ahaslides.com'>hi@ahaslides.com</a> for support.</div>"
        Utils.gaTrackEvent(
          this.gaCategory,
          'Add imported slides into presentation',
          'Import',
          'Failed',
        )
        this.$store.state.importStatus = 1
      }
    },

    _handleAfterImportDocument(data, presentationId) {
      this.$store.state.importStatus = 1
      this.$store.state.openImportModal = false
      this.$store.state.isReachLimitSlides = false

      Utils.gaTrackEvent(
        this.gaCategory,
        'Add imported slides into presentation',
        'Import',
        'Succeeded',
      )
      Utils.showToastSuccess('Import done!')

      if (data.body.isReachLimitSlides) {
        this.$store.state.isReachLimitSlides = true
      }

      if (this.importSocketData.data.presentationId) {
        if (
          this.$store.state.presentation.id !=
                        this.importSocketData.data.presentationId
        ) {
          this.$store.state.importStatus = 1
          return
        }
        const slideTypes = {}
        constants.allTypeSections.forEach((item) => {
          item.slideTypes.forEach((typeObj) => {
            slideTypes[typeObj.type] = typeObj
          })
        })

        data.body.result.forEach((item) => {
          if (item.type) {
            item.typeObj = slideTypes[item.type]
          }
        })

        this.$store.state.isNewPresentation = false
        EventBus.$emit('sortSlidePresentation')
      } else if (!this.$store.state.presentation.id) {
        this.$router.push({
          name: 'PresentationDetail',
          params: { id: presentationId },
        })
      }
    },

    async _createNewPresentation(payload, importPayload) {
      try {
        const res = await PresentationApi.createNewPresentation(payload)
        this.setCurrentUserHasCreatedPresentationAction()
        this._addImportedSlidesIntoPresentation(res.id, true, importPayload)
        Utils.gaTrackEvent(
          this.gaCategory,
          'Create new presentation',
          this.isOnboardingV3Showing ? 'Import from onboarding' : 'Import',
          null,
          { presentationId: res.id },
        )
      } catch (error) {
        // do nothing
      }
    },

    _handleImportingError() {
      Utils.showToastError('Import failed')
      this.$store.state.importError =
              "<div>Import failed. If this file has text in custom fonts, it’s recommended that you convert it into PDF first before importing to AhaSlides.<br />Please try again or contact us at <a href='mailto:hi@ahaslides.com'>hi@ahaslides.com</a> for support.</div>"
      Utils.gaTrackEvent(this.gaCategory, 'Import > Upload file', this.eventLabel, `${this.eventValue}${this.eventValue ? ' > ' : ''}'Import failed'`)
      this.$store.state.importStatus = 1
    },
  },
}
